import React from 'react';
import { Box, Body } from '@edreamsodigeo/prisma-design-system';
import { parseISO, differenceInDays } from 'date-fns';

interface OtherDayProps {
  arrivalDate: string;
  departureDate: string;
}

const parseLocalDay = (ISODateString: string): Date | null => {
  const [localDay] = ISODateString.match(/^\d+-\d{2}-\d{2}/) || [];
  return localDay ? parseISO(localDay) : null;
};

const numberOfDifferenceInDays = (
  arrivalDate: string,
  departureDate: string
): number => {
  const localDepartureDay = parseLocalDay(departureDate);
  const localDestinationDay = parseLocalDay(arrivalDate);
  if (!localDepartureDay || !localDestinationDay) {
    return 0;
  }
  return differenceInDays(localDestinationDay, localDepartureDay);
};

export const otherDayDestinationDiffObj = (
  arrivalDate: string,
  departureDate: string
): { days: number; otherDay: boolean; daysSign: string } => {
  const days = numberOfDifferenceInDays(arrivalDate, departureDate);
  return {
    days,
    otherDay: days !== 0,
    daysSign: Math.sign(days) < 0 ? '-' : '+',
  };
};

const OtherDay: React.FC<OtherDayProps> = ({ arrivalDate, departureDate }) => {
  const { days, otherDay, daysSign } = otherDayDestinationDiffObj(
    arrivalDate,
    departureDate
  );

  return (
    <Box>
      <Box sx={{ marginTop: '-5px', marginLeft: '-1px' }}>
        <Body color="neutral.80" type="xxSmall">
          {otherDay && `${daysSign}${Math.abs(days)}`}
        </Body>{' '}
      </Box>
    </Box>
  );
};

export default OtherDay;
